<template>
  <div class="row products-top">
    <div class="products-title">
      <div class="products-title-box" style="margin-left: 15px;">
        <h3 class="title">{{data.t}}</h3>
        <span class="subtitle">{{data.st}}</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  import homeTitleData_CN from '../data/CN/homeTitle_CN.json'
  import homeTitleData_EN from '../data/EN/homeTitle_EN.json'
  import homeTitleData_JP from '../data/JP/homeTitle_JP.json'
export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true }
  },
  data() {
    return {
      currentLanguage: '', // 当前语言
      data: {
        t: "",
        st: ""
      }
    }
  },
  mounted() {
    const _this = this
    window.addEventListener('setItemEvent', function(e) {
        // e.key : 是值发生变化的key
        // 例如 e.key==="token";
        // e.newValue : 是可以对应的新值
        if (e.key === 'language') {
            _this.currentLanguage = e.newValue
            var d = e.newValue
            _this.init(d)
        }
    })
  },
  methods: {
    init(e) {
      for (var i = 0; i < homeTitleData_CN.length; i++) {
        if (homeTitleData_CN[i].title == this.title) {
          if (e === 'CN') {
            this.data.t = homeTitleData_CN[i].title
            this.data.st = homeTitleData_CN[i].subtitle
          } else if (e === 'EN') {
            this.data.t = homeTitleData_EN[i].title
            this.data.st = homeTitleData_EN[i].subtitle
          } else if (e === 'JP') {
            this.data.t = homeTitleData_JP[i].title
            this.data.st = homeTitleData_JP[i].subtitle
          }
        }
      }
    }
  },
  created() {
   var language = localStorage.getItem('language')
   this.currentLanguage = language
   this.init(language)
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .products-nav {
    margin-top: 20px;
  }
  .products-top {
    margin-bottom: 10px !important;
  }
}

.products-top {
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
}

.products-title-box {
  width: 280px;
}

.products-title-box img {
  width: 100%;
}
.products-nav-items {
  display: inline-block;
  height: 100%;
  text-align: center;
  font-size: 14px;
  color: #666;
  padding: 4px 16px;
  margin-left: 10px;
}
.products-nav-box a:first-child {
  margin-left: 0;
}

.title {
  display: inline-block;
  /* font-family: 'myfont'; */
  color: #048bd4;
  margin-right: 10px;
}
.subtitle {
  /* font-family: 'myfont'; */
  color: #f15500;
}
</style>